<template>
    <div class="policy">
        <el-container>
            <el-main>
                <el-card>
                    <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
                        <el-row :gutter="20">
                            <el-col :sm="24" :md="12" :lg="6">
                                <el-form-item label="标题" prop="title">
                                    <el-input v-model="searchForm.title" placeholder="请输入标题"
                                              auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="6">
                                <el-form-item label="城市" prop="cityIds">
                                    <el-cascader
                                            clearable
                                            v-model="searchForm.cityId"
                                            :options="policyCity"
                                            :props="defaultData"
                                            @change="handleSearch"></el-cascader>


                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="6">
                                <el-button type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
                                <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>

                <el-card class="box-card">
                    <el-row :span="24">
                        <el-col :span="12">
                            <el-button type="primary" @click="addPolicyList" icon="el-icon-plus">新增</el-button>
                            <el-button type="danger" @click="batchDeletePolicy" icon="el-icon-minus">批量删除</el-button>
                        </el-col>
                        <el-col style="text-align: right" :span="12">
                            <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入
                            </el-button>
                            <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading"
                                       icon="el-icon-upload2">导出
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark"
                              style="margin-top: 20px; width: 100%;"
                              height="520" border @selection-change="selectionChange">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="city" label="城市"  width="320"></el-table-column>
                        <el-table-column prop="title" label="标题"></el-table-column>
                        <el-table-column label="海报" width="150">
                            <template slot-scope="scope">
                                <img :src="scope.row.poster" width="100%" height="100px"/>
                            </template>
                        </el-table-column>
                        <el-table-column  label="内容">
                            <template slot-scope="scope">
                               <div v-html="scope.row.content"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="操作" width="180" align="center">
                            <template slot-scope="scope">
                                <div class="operationGroup">
                                     <span @click="selection = scope.row.id, editFormVisible = true">
                                         <i class="information-icon el-icon-edit" title="编辑"></i>
                                      </span>
                                      <span @click="deletePolicy(scope.row)">
                                        <i class="information-icon el-icon-delete" title="删除"></i>
                                      </span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" style="margin-top: 20px;text-align: right;"
                                   :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                                   @size-change="sizeChange" @current-change="currentChange">
                    </el-pagination>
                </el-card>
            </el-main>
        </el-container>


        <el-dialog
                title="添加"
                :visible.sync="addFormVisible"
                width="800px"
                left
                :close-on-click-modal="false"
        >
            <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
                <el-row :gutter="20">
                    <el-col :sm="24" :md="12" :lg="12">
                        <el-form-item label="城市" prop="ids">
                            <el-cascader
                                    clearable
                                    v-model="addForm.ids"
                                    :options="policyCity"
                                    :props="defaultData"
                                 ></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="海报" prop="poster">
                            <el-upload
                                    class="picture"
                                    :action="fileAction"
                                    list-type="picture-card"
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload"
                            >
                                <img v-if="addForm.poster" :src="addForm.poster" class="avatar"/>
                                <i v-else class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="标题" prop="title">
                            <el-input
                                    style="width: 100%;"
                                    v-model="addForm.title"
                                    placeholder="请输入标题"
                                    auto-complete="off"
                                    maxlength="255"
                                    clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="内容" prop="content">
                            <div style="background: #FFF" v-if="showUe">
                                <UE  :value="ueTtext" ref="myQuillEditorTitle"></UE>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer" style="text-align: right">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addPolicy">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog
                title="编辑"
                :visible.sync="editFormVisible"
                width="800px"
                left
                :close-on-click-modal="false"
        >
            <el-form
                    class="edit-form-dialog"
                    ref="editForm"
                    :model="editForm"
                    :label-width="formLabelWidth"
                    :rules="editFormRules"
            >
                <el-row :gutter="20">
                    <el-col :sm="24" :md="12" :lg="12">
                        <el-form-item label="城市" prop="ids">
                            <el-cascader
                                    clearable
                                    v-model="editForm.ids"
                                    :options="policyCity"
                                    :props="defaultData"
                            >
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="海报" prop="poster">
                            <el-upload
                                    class="picture"
                                    :action="fileAction"
                                    list-type="picture-card"
                                    :show-file-list="false"
                                    :on-success="editHandleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload"
                            >
                                <img
                                        v-if="editForm.poster"
                                        :src="editForm.poster?editForm.poster:'https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/defaultImg.png'"
                                        class="avatar"
                                />
                                <i v-else class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="标题" prop="title">
                            <el-input
                                    style="width: 100%;"
                                    v-model="editForm.title"
                                    placeholder="请输入标题"
                                    auto-complete="off"
                                    maxlength="255"
                                    clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="内容" prop="content">
                            <div style="background: #FFF" v-if="showUe">
                                <UE  :value="ueTtext" ref="myQuillEditorTitle2"></UE>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: right">
                <el-button @click="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updatePolicy">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
            <el-upload
                    class="upload-demo"
                    :action="fileAction"
                    :on-success="handleSuccess"
                    :headers="reqData"
                    :file-list="fileList">
                <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
            </el-upload>
            <el-table ref="multipleTable" :data="importForm.rows" tooltip-effect="dark"
                      style="margin-top: 20px; width: 100%;"
                      height="520" border @selection-change="selectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="provinceId" label="城市"></el-table-column>
                <el-table-column prop="content" label="内容"></el-table-column>
                <el-table-column prop="poster" label="海报路径"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" style="text-align: left">
                <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import UE from "../conmom/CKEditorInformation.vue";

    export default {
        components: {UE},
        data() {
            return {
                ueTtext: "",
                showUe: false,
                page: {
                    rows: [],
                    total: 0,
                    pageSize: 10,
                    pageNumber: 1,
                    sortName: '',
                    sortOrder: ''
                },
                addFormVisible: false,
                editFormVisible: false,
                importFormVisible: false,
                searchForm: {
                    title: '',
                    cityId: '',
                },
                addForm: {
                    ids: '',
                    content: '',
                    poster: '',
                },
                policyCity: [],
                defaultData: {
                    value: 'id',
                    label: 'name',
                    children: 'childrenList'
                },
                addFormRules: {
                    ids: [{
                        required: true,
                        message: '请输入城市',
                        trigger: 'blur'
                    }],
                    content: [{
                        required: true,
                        message: '请输入内容',
                        trigger: 'blur'
                    }],
                    poster: [{
                        required: true,
                        message: '上传海报',
                        trigger: 'blur'
                    }],
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }, {
                        min: 1,
                        max: 20,
                        message: '标题长度在1到20个字'
                    }],
                },
                editForm: {
                    ids: '',
                    content: '',
                    poster: '',
                    title: '',
                },
                editFormRules: {
                    ids: [{
                        required: true,
                        message: '请输入城市',
                        trigger: 'blur'
                    }],
                    content: [{
                        required: true,
                        message: '请输入内容',
                        trigger: 'blur'
                    }],
                    poster: [{
                        required: true,
                        message: '上传海报',
                        trigger: 'blur'
                    }],
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }, {
                        min: 1,
                        max: 20,
                        message: '标题长度在1到20个字'
                    }],
                },
                importForm: {},
                formLabelWidth: '80px',
                selection: '',
                multipleSelection: '',
                ids: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                fileAction: `${process.env.BASE_URL}/policy/upload`,
                fileList: [],
                loading: false,


            };
        },
        computed: {
            reqData() {
                return this.$store.state.user;
            }
        },
        methods: {
            handleSearch(value){
                this.searchForm.cityId = value[1];
            },
            handleAvatarSuccess(res, file) {
                this.addForm.poster = res.data.split("?")[0];
            },
            editHandleAvatarSuccess(res, file) {
                this.editForm.poster = res.data.split("?")[0];
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error("上传头像图片大小不能超过 2MB!");
                }
                return isLt2M;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize
                this.pageList()
            },
            currentChange(pageNumber) {
                this.page.pageNumber = pageNumber
                this.pageList()
            },
            selectionChange(val) {
                this.multipleSelection = val;
                val.map(e => this.ids.push({id: e.id}))
            },
            getPolicy() {
                let that= this;
                this.api.policy.getPolicy({
                    id: this.selection
                }).then(result => {
                    this.$set(this,"editForm",result.data)
                    this.editForm.ids=[];
                    this.editForm.ids.push(result.data.provinceId);
                    this.editForm.ids.push(result.data.cityId);
                    that.ueTtext = result.data.content;
                    this.showUe = true;
                    console.log(that.ueTtext);
                }).catch(error => {
                    console.log(error)
                })
            },
            pageList() {
                this.searchForm.pageSize = this.page.pageSize;
                this.searchForm.pageNumber = this.page.pageNumber;
                this.searchForm.sortName = this.page.sortName;
                this.searchForm.sortOrder = this.page.sortOrder;
                this.api.policy.pageList(this.searchForm).then(result => {
                    this.page.rows = result.data.records;
                    this.page.total = result.data.total;
                }).catch(error => {
                    console.log(error)
                })
            },
            addPolicy() {
                this.addForm.content = this.$refs.myQuillEditorTitle._data.content;
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.api.policy.addPolicy(this.addForm).then(result => {
                            this.addFormVisible = false;
                        }).catch(error => {
                            console.log(error)
                        })
                    } else {
                        return false;
                    }
                })
            },
            updatePolicy() {
                console.log();
                this.editForm.content = this.$refs.myQuillEditorTitle2._data.content;
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.api.policy.updatePolicy(this.editForm).then(result => {
                            if (result.success) {
                                this.$message({
                                    type: 'success',
                                    message: result.message
                                });
                                this.editFormVisible = false;
                                this.pageList();
                            } else {
                                this.$message.error(result.message);
                            }
                        }).catch(error => {
                            console.log(error)
                        })
                    } else {
                        return false;
                    }
                })
            },
            deletePolicy(row) {
                this.$confirm('您确定要进行删除操作吗？', '系统消息', {
                    type: 'warning'
                }).then(() => {
                    this.api.policy.deletePolicy([{
                        id: row.id
                    }]).then(result => {
                        if (result.success) {
                            this.$message({
                                type: 'success',
                                message: result.message
                            });
                            this.pageList();
                        } else {
                            this.$message.error(result.message);
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }).catch(() => {

                });
            },
            addPolicyList() {
                this.addFormVisible = true;
                this.api.policy.getPolicyCity().then(result => {
                    console.log(result.data);
                    this.policyCity = result.data;
                }).catch(error => {
                    console.log(error)
                })
            },
            batchDeletePolicy() {
                this.$confirm('您确定要进行删除操作吗？', '系统消息', {
                    type: 'warning'
                }).then(() => {
                    this.api.policy.deletePolicy(this.ids).then(result => {
                        if (result.success) {
                            this.$message({
                                type: 'success',
                                message: result.message
                            });
                            this.pageList();
                        } else {
                            this.$message.error(result.message);
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }).catch(() => {

                });
            },
            reset() {
                this.$refs.searchForm.resetFields();
            },
            handleSuccess(response, file, fileList, $event) {
                this.importForm = response.data;
            },
            exportExcel() {
                this.loading = true;
                this.api.policy.exportExcel(this.searchForm).then(result => {
                    location.href = result.data;
                    this.loading = false;
                }).catch(error => {
                    console.log(error)
                })
            },
            importData() {
                this.api.policy.importData(this.importForm.rows).then(result => {
                    this.$message({
                        type: 'success',
                        message: result.message
                    });
                    this.pageList()
                    this.importFormVisible = false;
                }).catch(error => {
                    console.log(error)
                })
            },


        },
        watch: {

            'addFormVisible': function (newVal) {
                if (!newVal) {
                    this.$refs.addForm.resetFields();
                    this.ueTtext = "";
                    this.showUe = false;
                    this.pageList()
                }else {
                    this.showUe = true;
                }
            },
            'editFormVisible': function (newVal) {
                console.log(newVal);
                if (!newVal) {
                    this.$refs.editForm.resetFields();
                    this.showUe = false;
                    this.ueTtext = "";
                    this.pageList()
                } else {
                    this.ueTtext = "";
                    this.getPolicy()
                    console.log(2323232);
                }
            },

        },
        mounted() {
            this.pageList();
            this.api.policy.getPolicyCity().then(result => {
                console.log(result.data);
                this.policyCity = result.data;
            }).catch(error => {
                console.log(error)
            })

        }
    };
</script>
<style lang="less" rel="stylesheet/less">
    .policy {
        .el-textarea__inner {
            padding: 5px 45px 5px 15px;
        }
        .avatar-uploader .el-upload {
            // border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409eff;
        }
        .picture {
            .el-upload--picture-card {
                width: 130px;
                height: 100px;
                line-height: 110px;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 130px;
                height: 100px;
                text-align: center;
            }
            .avatar {
                border: 1px solid #c0ccda;
                width: 130px;
                height: 100px;
                display: block;
            }
        }
        .picture {
            .el-upload--picture-card i {
                margin: auto !important;
                line-height: 100px !important;
            }
        }
        .picture2 {
            .el-upload--picture-card {
                width: 100px;
                height: 100px;
                line-height: 110px;
                i {
                    line-height: 100px !important;
                    margin: auto !important;
                }
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                text-align: center;
            }
            .avatar {
                border: 1px solid #c0ccda;
                width: 100px;
                height: 100px;
                display: block;
            }
        }
    }
</style>
<style scoped>
    .information-icon {
        font-size: 16px;
        color: #4d94ff;
    }
</style>


// WEBPACK FOOTER //
// src/components/policyManage/index.vue